import React from 'react';

interface Props {
  active: boolean;
}

export const AnalyticsIcon: React.FC<Props> = ({
  active,
}: Props): JSX.Element => {
  return (
    <div className="submenu__body__link-icon">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {active ? (
          <path
            d="M10.6667 4C10.6667 2.89543 11.5621 2 12.6667 2C13.7713 2 14.6667 2.89543 14.6667 4C14.6667 5.10457 13.7713 6 12.6667 6C12.5587 6 12.4527 5.99144 12.3494 5.97497L10.9908 8.21365C11.2071 8.53314 11.3334 8.91848 11.3334 9.33333C11.3334 10.4379 10.4379 11.3333 9.33337 11.3333C8.73149 11.3333 8.19171 11.0675 7.82505 10.6468L5.3306 11.8938C5.33244 11.929 5.33337 11.9644 5.33337 12C5.33337 13.1046 4.43794 14 3.33337 14C2.2288 14 1.33337 13.1046 1.33337 12C1.33337 10.8954 2.2288 10 3.33337 10C4.04417 10 4.66837 10.3708 5.02308 10.9295L7.37738 9.75256C7.34855 9.61737 7.33337 9.47712 7.33337 9.33333C7.33337 8.22876 8.2288 7.33333 9.33337 7.33333C9.65477 7.33333 9.95847 7.40915 10.2275 7.54386L11.4261 5.56884C10.9635 5.20252 10.6667 4.63592 10.6667 4Z"
            fill={active ? 'white' : '#646C83'}
            style={{ transition: 'all 0.2s linear' }}
          />
        ) : (
          <path
            d="M12.6667 3C12.1144 3 11.6667 3.44772 11.6667 4C11.6667 4.55228 12.1144 5 12.6667 5C13.219 5 13.6667 4.55228 13.6667 4C13.6667 3.44772 13.219 3 12.6667 3ZM10.6667 4C10.6667 2.89543 11.5621 2 12.6667 2C13.7713 2 14.6667 2.89543 14.6667 4C14.6667 5.10457 13.7713 6 12.6667 6C12.5588 6 12.453 5.99146 12.3498 5.97503L10.991 8.21396C11.2071 8.53339 11.3334 8.91862 11.3334 9.33333C11.3334 10.4379 10.4379 11.3333 9.33337 11.3333C8.73146 11.3333 8.19166 11.0674 7.82501 10.6467L5.3306 11.8937C5.33244 11.9289 5.33337 11.9643 5.33337 12C5.33337 13.1046 4.43794 14 3.33337 14C2.2288 14 1.33337 13.1046 1.33337 12C1.33337 10.8954 2.2288 10 3.33337 10C4.04415 10 4.66832 10.3708 5.02304 10.9295L7.37737 9.75249C7.34854 9.61732 7.33337 9.4771 7.33337 9.33333C7.33337 8.22876 8.2288 7.33333 9.33337 7.33333C9.6549 7.33333 9.9587 7.4092 10.2279 7.54401L11.4264 5.56905C10.9636 5.20274 10.6667 4.63604 10.6667 4ZM9.33337 8.33333C8.78109 8.33333 8.33337 8.78105 8.33337 9.33333C8.33337 9.88562 8.78109 10.3333 9.33337 10.3333C9.88566 10.3333 10.3334 9.88562 10.3334 9.33333C10.3334 8.78105 9.88566 8.33333 9.33337 8.33333ZM3.33337 11C2.78109 11 2.33337 11.4477 2.33337 12C2.33337 12.5523 2.78109 13 3.33337 13C3.88566 13 4.33337 12.5523 4.33337 12C4.33337 11.4477 3.88566 11 3.33337 11Z"
            fill={active ? '#646c8391' : '#646C83'}
            style={{ transition: 'all 0.2s linear' }}
          />
        )}
      </svg>
    </div>
  );
};
